import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-tile',
  templateUrl: './button-tile.component.html',
  styleUrls: ['./button-tile.component.scss']
})
export class ButtonTileComponent implements OnInit {
  @Input() text: string;
  @Input() icon: string | null = null;
  @Input() color: string;

  constructor() {}

  ngOnInit() {}
}
